import React from 'react'
import classNames from 'classnames'

import './inlineloader.css'

const InlineLoader = ({className = '', theme = {} }) => (
  <span className={classNames('loader', className, { [`loader--main`]: true })} />
)

InlineLoader.defaultProps = { theme: {} }

export default InlineLoader;



// WEBPACK FOOTER //
// ./src/modules/common/components/inlineloader/inlineloader.js